var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ranking-chart2",attrs:{"id":"ranking"}},[_c('span',{staticClass:"homepage-title"},[_vm._v("运营类型")]),_c('div',{staticClass:"chart-box"},[_c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"ranking-chart2"}})])])
}]

export { render, staticRenderFns }